var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 79,
    viewBox: "0 0 87 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4397 29.9809L39.1431 30.2839V18.6885C41.5204 16.5119 56.4167 3.7898 69.2923 13.2343L39.5128 43.9193V29.9809H39.4397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9421 56.4834C67.9421 56.4834 52.9598 73.8403 39.147 79V55.4122H51.3692L57.7619 48.8271V48.7973H44.5122L57.7619 35.1448L57.7748 35.1277L74.2273 18.1763C86.183 34.415 67.9421 56.4792 67.9421 56.4792V56.4834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0771 36.5318V55.4122H39.143V79C25.3302 73.8403 10.3436 56.4834 10.3436 56.4834C10.3436 56.4834 -10.7002 31.0221 7.23113 14.6724C20.4722 2.59901 36.6496 16.4137 39.1387 18.6884V30.2838L33.0728 36.5318H33.0771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9998 5.01885L74.223 18.1805C73.3374 16.977 72.2884 15.8034 71.0503 14.6767C70.4699 14.1475 69.881 13.6695 69.292 13.2385L82.1376 0L86.9998 5.01885Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 79,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIcon);
export default __webpack_public_path__ + "static/media/love-icon.ff5ada848b12bc69a5b9c42ba8558a6e.svg";
export { ForwardRef as ReactComponent };